import { useAuditReportsListReportDefinition } from '@mi-front/api-v2';
import { QueryView } from '@mi-front/ui';
import { ReportDefinitionList } from './ReportDefinitionList';

interface ReportDefinitionListPanelProps {
  reportType: string;
}

/**
 * Loads and renders the report-definition table for one report type (chip content).
 */
export function ReportDefinitionListPanel({ reportType }: ReportDefinitionListPanelProps) {
  const definitionsQuery = useAuditReportsListReportDefinition({
    reportType,
  });

  return (
    <QueryView query={definitionsQuery}>
      {(definitions) => <ReportDefinitionList definitions={definitions} reportType={reportType} />}
    </QueryView>
  );
}
